import { SchedulerEvent } from '@progress/kendo-angular-scheduler';
import moment from 'moment';

/* eslint-disable */

const baseData: any[] = [
  {
    TaskID: 4,
    OwnerID: 2,
    Title: 'Bowling tournament',
    Description: '',
    StartTimezone: null,
    Start: '2013-06-09T21:00:00.000Z',
    End: '2013-06-10T00:00:00.000Z',
    EndTimezone: null,
    RecurrenceRule: null,
    RecurrenceID: null,
    RecurrenceException: null,
    IsAllDay: false,
  },
  {
    TaskID: 5,
    OwnerID: 2,
    Title: 'Take the dog to the vet',
    Description: '',
    StartTimezone: null,
    Start: '2013-06-10T07:00:00.000Z',
    End: '2013-06-10T08:00:00.000Z',
    EndTimezone: null,
    RecurrenceRule: null,
    RecurrenceID: null,
    RecurrenceException: null,
    IsAllDay: false,
  },
  {
    TaskID: 6,
    OwnerID: 2,
    Title: 'Call Charlie about the project',
    Description: '',
    StartTimezone: null,
    Start: '2013-06-11T11:30:00.000Z',
    End: '2013-06-11T13:00:00.000Z',
    EndTimezone: null,
    RecurrenceRule: null,
    RecurrenceID: null,
    RecurrenceException: null,
    IsAllDay: false,
  },
  {
    TaskID: 7,
    OwnerID: 3,
    Title: 'Meeting with Alex',
    Description: '',
    StartTimezone: null,
    Start: '2013-06-12T11:00:00.000Z',
    End: '2013-06-12T12:00:00.000Z',
    EndTimezone: null,
    RecurrenceRule: null,
    RecurrenceID: null,
    RecurrenceException: null,
    IsAllDay: false,
  },
  {
    TaskID: 9,
    OwnerID: 2,
    Title: "Alex's Birthday",
    Description: '',
    StartTimezone: null,
    Start: '2013-06-14T02:00:00.000Z',
    End: '2013-06-14T02:00:00.000Z',
    EndTimezone: null,
    RecurrenceRule: null,
    RecurrenceID: null,
    RecurrenceException: null,
    IsAllDay: true,
  },
  {
    TaskID: 12,
    OwnerID: 2,
    Title: 'Car Service',
    Description: 'Might come to work later!',
    StartTimezone: null,
    Start: '2013-06-24T08:30:00.000Z',
    End: '2013-06-24T09:30:00.000Z',
    EndTimezone: null,
    RecurrenceRule: 'FREQ=DAILY;COUNT=5',
    RecurrenceID: null,
    RecurrenceException: null,
    IsAllDay: false,
  },
];

const currentYear = new Date().getFullYear();
const parseAdjust = (eventDate: string): Date => {
  const date = new Date(eventDate);
  date.setFullYear(currentYear);
  return date;
};

const randomInt = (min, max): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const displayDate = new Date(currentYear, 5, 24);

export const sampleData = baseData.map(
  (dataItem) =>
    <SchedulerEvent>{
      id: dataItem.TaskID,
      start: parseAdjust(dataItem.Start),
      startTimezone: dataItem.startTimezone,
      end: parseAdjust(dataItem.End),
      endTimezone: dataItem.endTimezone,
      isAllDay: dataItem.IsAllDay,
      title: dataItem.Title,
      description: dataItem.Description,
      recurrenceRule: dataItem.RecurrenceRule,
      recurrenceId: dataItem.RecurrenceID,
      recurrenceException: dataItem.RecurrenceException,

      roomId: dataItem.RoomID,
      ownerID: dataItem.OwnerID,
    }
);

export const sampleDataWithResources = baseData.map(
  (dataItem) =>
    <SchedulerEvent>{
      id: dataItem.TaskID,
      start: parseAdjust(dataItem.Start),
      startTimezone: dataItem.startTimezone,
      end: parseAdjust(dataItem.End),
      endTimezone: dataItem.endTimezone,
      isAllDay: dataItem.IsAllDay,
      title: dataItem.Title,
      description: dataItem.Description,
      recurrenceRule: dataItem.RecurrenceRule,
      recurrenceId: dataItem.RecurrenceID,
      recurrenceException: dataItem.RecurrenceException,
      roomId: randomInt(1, 2),
      attendees: [randomInt(1, 3)],
    }
);

export const sampleDataWithCustomSchema = baseData.map((dataItem) => ({
  ...dataItem,
  Start: parseAdjust(dataItem.Start),
  End: parseAdjust(dataItem.End),
}));

const today = moment();

// Start of work week (Monday 00:00:00)
export const startOfWorkWeek = today
  .clone()
  .startOf('isoWeek')
  .format('YYYY-MM-DD');

// End of week including weekend (Sunday 23:59:59)
export const endOfWorkWeek = today
  .clone()
  .startOf('isoWeek')
  .add(6, 'days')
  .endOf('day')
  .format('YYYY-MM-DD');

export function formatStartToAPI(date: Date): string {
  return moment(date).format('YYYY-MM-DD');
}

export function formatEndToAPI(date: Date): string {
  return moment(date).subtract(1, 'day').format('YYYY-MM-DD');
}


export function formatEndToAPIDate(date: Date): string {
  return moment(date).add(6, 'days').format('YYYY-MM-DD');
}